module.exports = __webpack_public_path__ + "static/media/Cactus-Mania.ab0c5222.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/video/Cactus-Mania.mp4
// module id = 65
// module chunks = 0